import LogoInput from 'Presentation/Components/LogoInput'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
// import Select from 'react-select'
import Editor from 'Presentation/Components/Editor'
import { QUILL_MODULES_MININMAL_CONFIG, QUILL_FORMATS_MINIMAL_CONFIG } from 'Configuration/Quill'

// import clsx from 'clsx'
import { isMobileDevice } from '_metronic/assets/ts/_utils'

const GenerationInformation: React.FC = () => {
	return (
		<div className="card border border-kumopack-grey-200">
			<div className="card-header border-0 mt-4">
				<div className="card-title">
					{/* Title */}
					<div>
						<h4 className="text-kumopack-grey-900 fw-bold mb-2">1. ข้อมูลทั่วไป</h4>
						<div className="text-kumopack-grey-600 fs-6">ชื่อสินค้า ภาพ หมวดหมู่ </div>
					</div>
				</div>
				<div className="mt-2 separator border-1px w-100 border-kumopack-grey-200"></div>
			</div>

			<div className="card-body">
				<LogoInput wording="ภาพสินค้า" />
				<LogoInput
					wording="วีดีโอสินค้า"
					description={
						<div>
							<ul>
								<li>ขนาดไม่เกิน 30MB, 1280x1280px</li>
								<li>ระยะเวลา: 10-60 นาที</li>
								<li>นามสกุลไฟล์: MP4</li>
								<li>
									หมายเหตุ: คุณสามารถเผยแพร่สินค้าชิ้นนี้ได้ตั้งแต่ ระหว่างที่วิดีโอกำลังอัปโหลด
									โดยวิดีโอจะแสดงให้เห็นหลัง การอัปโหลดเสร็จสิ้น
								</li>
							</ul>
						</div>
					}
				/>
				<FormGenerator
					formKey="productName"
					inputType="plain"
					label="ชื่อสินค้า"
					containerClassName="mb-5"
					isHorizontal={!isMobileDevice()}
					tooltip='ชื่อสินค้าที่แสดงให้ผู้ซื้อเห็น ตัวอย่างเช่น "เสื้อยืดผู้ชาย สีดำ"'
				/>
					<FormGenerator
					formKey="sku"
					inputType="plain"
					label="รหัสสินค้า / SKU"
					containerClassName="mb-5"
					isHorizontal={!isMobileDevice()}
					tooltip='รหัสสินค้าที่เป็นเลขหรือตัวอักษร ที่ใช้เพื่อระบุสินค้านี้ ตัวอย่างเช่น "SKU-123456"'
				/>
				{/* <div className="mb-5 d-flex flex-column flex-xl-row align-items-xl-">
					<label
						className={clsx('form-label', {
							'col-3 mb-0': !isMobileDevice(),
						})}>
						หมวดหมู่
					</label>

					<Select
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
								borderRadius: 8,
								height: 40,
							}),
						}}
						className="w-100"
						options={[{ name: 'Salesperson' }, { name: 'Salesperson' }]}
						getOptionLabel={option => option.name}
						getOptionValue={option => option.name}
						components={{
							IndicatorSeparator: () => null,
						}}
					/>
				</div> */}
				<div className={`mb-5 d-flex flex-column flex-xl-row`}>
					<label
						className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
						data-testid="form-input-label-component">
						<div className="d-flex flex-column">
							<span>ข้อมูลสินค้า</span>
						</div>
					</label>

					<div className="col-12 col-xl-9">
						<Editor
							modules={QUILL_MODULES_MININMAL_CONFIG}
							formats={QUILL_FORMATS_MINIMAL_CONFIG}
							height={250}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

export default GenerationInformation
